import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Link } from 'react-router-dom';
import CreditChart from './CreditChart'
import { message } from "antd";
import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import Layout from 'Layout'
import './styles.scss'
import { mixGetV1 } from 'services/mixin';


const User: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [profile, setProfile] = useState<any>(null);
  const [AIChat, setAIChat] = useState([])
  const [AIWriter, setAIWriter] = useState([])
  const [packageHighLight, setPackageHighLight] = useState([])
  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)
  const toggleModal = (open: boolean) => {
    setModalOpen(open);
  };
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    },
  })
  function Arrow(props: {
    disabled: boolean
    left?: boolean
    onClick: (e: any) => void
  }) {
    const disabled = props.disabled ? " arrow--disabled" : ""
    return (
      <svg
        onClick={props.onClick}
        className={`arrow ${props.left ? "arrow--left" : "arrow--right"
          } ${disabled}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        {props.left && (
          <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        )}
        {!props.left && (
          <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        )}
      </svg>
    )
  }

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await mixGetV1("/api/v1/fe/customer/profile", { auth: true });
        if (res?.status) {
          setProfile(res.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const getAiChat = async () => {
      try {
        const res = await mixGetV1(`/api/v1/fe/model_chats?model_chat_category_id=101`)
        if (res?.status) {
          setAIChat(res.data.items);
        }
      } catch (err) {
        console.error(err);
      }
    }
    getAiChat();
    const getAiWriter = async () => {
      try {
        const res = await mixGetV1(`/api/v1/fe/model_chats?model_chat_category_id=103`)
        if (res?.status) {
          setAIWriter(res.data.items);
        }
      } catch (err) {
        console.error(err);
      }
    }
    getAiWriter();
  }, [])

  const referralCode = useMemo(() => {
    if (!profile) return "PBVZXJ7YHQ";
    return profile.contact_affiliate?.status === 1
      ? profile.info?.code || profile.code || ""
      : "PBVZXJ7YHQ";
  }, [profile]);

  const referralLink = `${window.origin}/register/${referralCode}`;
  const copyTextToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success({
        content: "Đã sao chép thành công!",
        style: { fontSize: 16, padding: 10 },
      });
    } catch (error) {
      message.error({
        content: "Trình duyệt không hỗ trợ hoặc domain chưa có SSL!",
        style: { fontSize: 16, padding: 10 },
      });
    }
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setIsSearching(true);

    // Giả lập delay tìm kiếm
    setTimeout(() => {
      setIsSearching(false);
    }, 800);
  };

  const [modalOpenView, setModalOpenView] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const [userName, setUserName] = useState<string>('')

  // Đóng modal khi nhấn phím Escape
  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === "Escape") setModalOpen(false);
    };
    window.addEventListener("keyup", handleKeyUp);
    return () => window.removeEventListener("keyup", handleKeyUp);
  }, []);
  useEffect(() => {
    // Lấy dữ liệu user từ localStorage
    const storedUser = localStorage.getItem('user')
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser)
        setUserName(parsedUser.fullname || 'Admin') // nếu không có fullname thì fallback là "Admin"
      } catch (error) {
        console.error('Lỗi khi parse user:', error)
      }
    }
  }, [])

  // Đóng modal khi click ra ngoài
  const handleClickOutside = (e: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    if (modalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [modalOpen]);

  useEffect(() => {
    const getPackageHighLight = async () => {
      try {
        const res = await mixGetV1('/api/v1/fe/packages?sort[]=created_at,desc')

        if (res.status) {
          const items = res.data.items.map((item: any) => ({
            ...item,
            content: item?.content ? JSON.parse(item?.content) : null
          }))

          const list = items.filter((item: any) => item?.content?.val0 === 1)

          setPackageHighLight(list)
        }
      } catch (err) {
        console.log(err)
      }
    }
    getPackageHighLight()
  }, [])
  useEffect(() => {
    if (loaded && instanceRef.current) {
      instanceRef.current.update(); // hoặc .resize()
    }
  }, [packageHighLight, loaded]);


  return (
    <Layout>
      <div id="lqd-titlebar" className="lqd-titlebar pt-6 pb-7 border-b transition-colors" layout-wide="">
        <div className="lqd-titlebar-container flex flex-wrap items-center justify-between gap-y-4 container">
          <div className="lqd-titlebar-col lqd-titlebar-col-nav group/titlebar-nav flex w-full flex-col gap-2 lg:w-7/12">
            {/* <p className="lqd-titlebar-pretitle text-xs text-foreground/70 m-0">
              Dashboard
            </p> */}
            <h1 className="lqd-titlebar-title m-0">
              Welcome, {userName}.
            </h1>
          </div>

          {/* <div className="lqd-titlebar-col lqd-titlebar-col-actions group/titlebar-actions flex w-full flex-wrap gap-y-3 max-lg:has-[.max-lg\:hidden:only-child]:hidden lg:w-5/12 lg:justify-end">
            <div className="lqd-titlebar-actions flex flex-wrap items-center gap-2 max-lg:hidden">
              <a
                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                href="https://demo.magicproject.ai/dashboard/user/openai/documents/all"
              >
                My Documents
              </a>
              <a
                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                href="https://demo.magicproject.ai/dashboard/user/openai"
              >
                <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 5l0 14"></path>
                  <path d="M5 12l14 0"></path>
                </svg>
                New
              </a>
            </div>
          </div> */}

          <div className="lqd-titlebar-after w-full">
            <ul className="lqd-filter-list mt-1 flex list-none flex-wrap items-center gap-x-4 gap-y-2 text-heading-foreground max-sm:gap-3">
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5 active"
                  href="/ai-chat"
                >
                  AI Chat
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="/ai-chat-images"
                >
                  AI Chat Image
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="/user/openai"
                >
                  AI Writer
                </a>
              </li>
            </ul>
            {/* <ul className="lqd-filter-list mt-1 flex list-none flex-wrap items-center gap-x-4 gap-y-2 text-heading-foreground max-sm:gap-3">
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5 active"
                  href="#all"
                >
                  All
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="#all"
                >
                  AI Assistant
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="#plan"
                >
                  Your Plan
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="#team"
                >
                  Team Members
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="#recent"
                >
                  Recent
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="#documents"
                >
                  Documents
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="#templates"
                >
                  Templates
                </a>
              </li>
              <li>
                <a
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  href="#all"
                >
                  Overview
                </a>
              </li>
            </ul> */}
          </div>
        </div>
      </div>

      <div className="lqd-page-content-container h-full container">
        <div className="flex flex-wrap justify-between gap-8 py-5">
          <div className="grid w-full grid-cols-1 gap-10" id="all">
            {/* <div className="lqd-announcement" data-name="dashboard_first" x-data="{ show: true }" x-ref="announcement">
              <div className="lqd-card text-card-foreground bg-card-background w-full transition-all group/card lqd-card-outline border border-card-border rounded-card lqd-announcement-card relative bg-cover bg-center" x-ref="announcementCard">
                <div className="lqd-card-body relative only:grow lqd-card-lg py-8 px-10">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div>
                      <h3 className="mb-3">
                        Introducing External Chatbots.
                      </h3>
                      <p className="mb-4">
                        Allow end users to create, train, and embed custom chatbots directly onto their websites.
                      </p>
                      <div className="flex flex-wrap gap-2">
                        <a
                          className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none font-medium"
                          href="https://magicai.liquid-themes.com/dashboard/chatbot"
                        >
                          <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 5l0 14"></path>
                            <path d="M5 12l14 0"></path>
                          </svg>
                          Try it Now
                        </a>
                        <a
                          className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs dark:hover:bg-foreground dark:hover:text-background dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md py-2 px-4 lqd-btn-hover-danger hover:text-white hover:bg-rose-500 hover:border-rose-500 hover:outline-rose-500 focus-visible:text-white focus-visible:bg-rose-500 focus-visible:border-rose-500 focus-visible:outline-rose-500 font-medium"
                          href="#"
                        >
                          Dismiss
                        </a>
                      </div>
                    </div>
                    <img className="announcement-img announcement-img-dark peer hidden w-28 shrink-0 dark:block" src="https://demo.magicproject.ai/upload/images/fioLUuDi-ann-img-dark.png" alt="Introducing External Chatbots." />
                    <img className="announcement-img announcement-img-light w-28 shrink-0 dark:peer-[&amp;.announcement-img-dark]:hidden" src="https://demo.magicproject.ai/upload/images/CkBtaz4H-ann-img.png" alt="Introducing External Chatbots." />
                  </div>
                </div>
              </div>
            </div> */}

            <div data-name="dashboard_two" className="lqd-card text-card-foreground bg-card-background w-full transition-all group/card lqd-card-outline border border-card-border rounded-card">
              <div className="lqd-card-body relative only:grow lqd-card-lg py-8 px-10 max-sm:p-7">
                <h3 className="mb-6 flex items-center gap-3">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.7588 7.85618L17.1437 8.18336V8.18568C16.3659 8.34353 15.6517 8.72701 15.0905 9.28825C14.5292 9.8495 14.1458 10.5636 13.9879 11.3415L13.6607 12.9565C13.6262 13.1155 13.5383 13.2578 13.4117 13.3599C13.285 13.462 13.1273 13.5177 12.9646 13.5177C12.8019 13.5177 12.6442 13.462 12.5175 13.3599C12.3909 13.2578 12.303 13.1155 12.2685 12.9565L11.9413 11.3415C11.7837 10.5635 11.4003 9.84922 10.839 9.28793C10.2777 8.72663 9.56345 8.34324 8.78546 8.18568L7.17042 7.8585C7.00937 7.82552 6.86464 7.73795 6.76071 7.61058C6.65678 7.48321 6.60001 7.32386 6.60001 7.15946C6.60001 6.99507 6.65678 6.83572 6.76071 6.70835C6.86464 6.58098 7.00937 6.4934 7.17042 6.46043L8.78546 6.13324C9.56339 5.97554 10.2776 5.5921 10.8389 5.03084C11.4001 4.46957 11.7836 3.75536 11.9413 2.97743L12.2685 1.36239C12.303 1.20344 12.3909 1.06109 12.5175 0.959015C12.6442 0.856935 12.8019 0.80127 12.9646 0.80127C13.1273 0.80127 13.285 0.856935 13.4117 0.959015C13.5383 1.06109 13.6262 1.20344 13.6607 1.36239L13.9879 2.97743C14.1458 3.75529 14.5292 4.46943 15.0905 5.03067C15.6517 5.59192 16.3659 5.9754 17.1437 6.13324L18.7588 6.45811C18.9198 6.49108 19.0645 6.57866 19.1685 6.70603C19.2724 6.8334 19.3292 6.99275 19.3292 7.15714C19.3292 7.32154 19.2724 7.48089 19.1685 7.60826C19.0645 7.73563 18.9198 7.8232 18.7588 7.85618ZM6.94895 16.0393L6.51038 16.1286C5.96946 16.2383 5.47282 16.5037 5.08244 16.8939C4.69206 17.2841 4.42523 17.7806 4.31524 18.3214L4.2259 18.76C4.202 18.8835 4.13584 18.9949 4.03877 19.075C3.9417 19.1551 3.81978 19.1989 3.69394 19.1989C3.56809 19.1989 3.44617 19.1551 3.3491 19.075C3.25204 18.9949 3.18587 18.8835 3.16197 18.76L3.07263 18.3214C2.96278 17.7805 2.69599 17.2839 2.30559 16.8937C1.91518 16.5035 1.41847 16.237 0.877485 16.1274L0.43892 16.0381C0.315366 16.0142 0.203985 15.948 0.123895 15.851C0.0438042 15.7539 0 15.632 0 15.5061C0 15.3803 0.0438042 15.2584 0.123895 15.1613C0.203985 15.0642 0.315366 14.9981 0.43892 14.9742L0.877485 14.8848C1.41862 14.7752 1.91545 14.5085 2.30587 14.1181C2.69629 13.7276 2.96299 13.2308 3.07263 12.6897L3.16197 12.2511C3.18587 12.1276 3.25204 12.0162 3.3491 11.9361C3.44617 11.856 3.56809 11.8122 3.69394 11.8122C3.81978 11.8122 3.9417 11.856 4.03877 11.9361C4.13584 12.0162 4.202 12.1276 4.2259 12.2511L4.31524 12.6897C4.42482 13.231 4.69148 13.728 5.08189 14.1186C5.4723 14.5092 5.96915 14.7761 6.51038 14.886L6.94895 14.9753C7.0725 14.9992 7.18388 15.0654 7.26397 15.1625C7.34407 15.2595 7.38787 15.3814 7.38787 15.5073C7.38787 15.6331 7.34407 15.7551 7.26397 15.8521C7.18388 15.9492 7.0725 16.0154 6.94895 16.0393Z"
                      fill="url(#paint0_linear_213_525)"
                    ></path>
                    <defs>
                      <linearGradient id="paint0_linear_213_525" x1="1.1976e-07" y1="4.55439" x2="15.5124" y2="18.9291" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#82E2F4"></stop>
                        <stop offset="0.502" stop-color="#8A8AED"></stop>
                        <stop offset="1" stop-color="#6977DE"></stop>
                      </linearGradient>
                    </defs>
                  </svg>

                  Hey, How can I help you?
                </h3>
                <form
                  className="header-search relative transition-all group/header-search mb-0 w-full header-search-style-modern"
                  x-data="liquidHeaderSearch"
                >
                  <div className="header-search-input-wrap relative w-full">
                    <div className="header-search-border pointer-events-none absolute -inset-1 overflow-hidden rounded-[calc(var(--input-rounded)*var(--input-rounded-multiplier)+0.25rem)] bg-heading-foreground/5">
                      <div className="header-search-border-play absolute left-1/2 top-1/2 aspect-square min-h-full min-w-full -translate-x-1/2 -translate-y-1/2 rounded-[inherit]">
                        <div className="header-search-border-play-inner absolute min-h-full min-w-full opacity-0"></div>
                      </div>
                    </div>

                    <div className="lqd-input-container relative peer">
                      <input
                        onClick={() => toggleModal(true)}
                        id=""
                        className="lqd-input block peer w-full px-4 py-2 border border-input-border text-base ring-offset-0 focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg header-search-input transition-colors placeholder-shown:text-ellipsis bg-background border-none h-12 text-heading-foreground shadow-[0_4px_8px_rgba(0,0,0,0.05)] placeholder:text-heading-foreground"
                        name=""
                        value=""
                        type="text"
                        placeholder="Search for documents, templates, tools and more" />
                    </div>

                    <span className="header-search-loader absolute end-12 top-1/2 -translate-y-1/2" x-show="isSearching" style={{ display: 'none' }}>
                      <svg stroke-width="1.5" role="status" className="animate-spin" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 3a9 9 0 1 0 9 9"></path>
                      </svg>
                    </span>
                  </div>
                </form >

                {/* Modal overlay */}
                {modalOpen && (
                  <div className="fixed inset-0 z-[999] flex items-center justify-center overflow-y-auto bg-black/30">
                    {/* Bấm ra ngoài để đóng */}
                    <div
                      className="fixed inset-0"
                      onClick={() => toggleModal(false)}
                    ></div>

                    {/* Modal content */}
                    <div
                      className="relative z-[100] max-h-[95vh] min-w-[clamp(250px,760px,90vw)] max-w-[min(calc(100%-2rem),630px)] overflow-y-auto rounded-xl bg-white shadow-2xl"
                      onClick={(e) => e.stopPropagation()} // chặn click bên trong
                    >
                      {/* Header input */}
                      <div className="relative flex items-center justify-between border-b">
                        <div className="relative flex w-full">
                          <svg
                            strokeWidth="1.5"
                            className="pointer-events-none absolute start-4 top-1/2 z-10 size-5 -translate-y-1/2 text-gray-600"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                            <path d="M21 21l-6 -6"></path>
                          </svg>

                          <input
                            className="header-search-input h-[70px] w-full bg-transparent ps-12 text-heading-foreground outline-none transition-colors placeholder:text-foreground placeholder-shown:text-ellipsis max-lg:rounded-md max-sm:text-base ps-14 pr-10"
                            type="text"
                            placeholder="Search for anything..."
                            value={searchTerm}
                            onChange={handleSearch}
                          />

                          {isSearching && (
                            <span className="absolute end-5 top-1/2 -translate-y-1/2">
                              <svg
                                strokeWidth="1.5"
                                role="status"
                                className="animate-spin text-gray-500"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M12 3a9 9 0 1 0 9 9"></path>
                              </svg>
                            </span>
                          )}
                        </div>

                        {!isSearching && (
                          <div className="pointer-events-none absolute end-5 top-1/2 flex -translate-y-1/2 whitespace-nowrap hidden sm:flex">
                            <span className="text-xs text-gray-400">
                              Templates, Documents, Bots and more
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Nội dung modal */}
                      <div className="max-h-[min(440px,80vh)] overflow-y-auto rounded-xl bg-white shadow-inner">
                        {searchTerm ? (
                          <div className="p-6">
                            <h3 className="text-base font-medium mb-4 border-b pb-2">
                              Search results
                            </h3>
                            <p>Kết quả cho: <strong>{searchTerm}</strong></p>
                          </div>
                        ) : (
                          <div>
                            <a
                              className="lqd-btn group inline-flex items-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none w-full justify-between rounded-none border-b px-5 py-4 font-heading !text-base !font-medium text-heading-foreground"
                              style={{ fontWeight: 'inherit' }}
                              href="https://demo.magicproject.ai/dashboard/user/openai/documents/all"
                            >
                              Recently Launched
                              <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M9 6l6 6l-6 6"></path>
                              </svg>
                            </a>
                            {/* <p className="text-gray-500 text-sm py-4 px-5">Không có tìm kiếm gần đây.</p> */}
                            <div className="recent-lunched-container flex flex-col" x-html="recentLunchedDocs">
                              <ul>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/gqZRp3Oadmin-admin-workbook">
                                    <span
                                      style={{ background: '#e3e49f' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/mDRivedadmin-admin-workbook">
                                    <span
                                      style={{ background: '#e3e49f' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/CUJb77Eadmin-admin-workbook">
                                    <span
                                      style={{ background: '#d1c5de' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm56-157h489L578 583 446 754l-93-127-117 152Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    upscale
                                    <small className="ms-auto text-foreground/50">Image</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/I5lWsOBadmin-admin-workbook">
                                    <span
                                      style={{ background: '#a3d6c2' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/lRpxiCyadmin-admin-workbook">
                                    <span
                                      style={{ background: '#a3d6c2' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/gqZRp3Oadmin-admin-workbook">
                                    <span
                                      style={{ background: '#e3e49f' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/mDRivedadmin-admin-workbook">
                                    <span
                                      style={{ background: '#e3e49f' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/CUJb77Eadmin-admin-workbook">
                                    <span
                                      style={{ background: '#d1c5de' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm56-157h489L578 583 446 754l-93-127-117 152Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    upscale
                                    <small className="ms-auto text-foreground/50">Image</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/I5lWsOBadmin-admin-workbook">
                                    <span
                                      style={{ background: '#a3d6c2' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                                <li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
                                  <a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/lRpxiCyadmin-admin-workbook">
                                    <span
                                      style={{ background: '#a3d6c2' }}
                                      className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
                                    >
                                      <span className="flex size-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                                          <path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
                                        </svg>
                                      </span>
                                    </span>
                                    Document
                                    <small className="ms-auto text-foreground/50">Document</small>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div >
            </div >
          </div>

          <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card lg:w-[48%] w-full text-center" id="plan" data-name="dashboard_three">
            <div className="lqd-card-body relative only:grow lqd-card-lg py-8 md:px-10 px-5">
              <h3 className="mb-8">
                Your Plan
              </h3>

              <p className="mb-3 font-medium leading-relaxed text-foreground/70">
                You have no subscription at the moment. Please select a subscription plan or a token pack. Total
                <strong className="text-foreground"> Unlimited </strong>
                word and
                <strong className="text-foreground">
                  Unlimited
                </strong>
                image tokens left.
              </p>

              <div className="relative">
                <CreditChart />
                <h3 className="group absolute left-1/2 top-[calc(50%-5px)] m-0 -translate-x-1/2 text-center text-xs font-normal">
                  <strong className="block text-[2em] font-semibold leading-none max-sm:text-[1.5em]"> Unlimited </strong>
                  Words
                </h3>
              </div>

              <div className="mt-4 flex flex-wrap items-center justify-center gap-4">
                <div className="lqd-remaining-credit relative mx-2 flex flex-col gap-3 text-2xs items-center" expanded-modal-trigger="expanded-modal-trigger" modal-trigger-variant="ghost-shadow">
                  <div
                    className="lqd-modal lqd-modal-default static">
                    <a
                      className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                      href="/credit-your"
                    // onClick={() => setModalOpenView(true)}
                    >
                      View Your Credits
                    </a>
                    {/* Modal */}
                    {modalOpenView && (
                      <div className="lqd-modal-modal z-[999] flex items-center justify-center overflow-y-auto overscroll-contain fixed inset-0">
                        <div className="lqd-modal-backdrop fixed inset-0 bg-black/5 backdrop-blur-sm" onClick={() => setModalOpenView(false)}></div>
                        <div className="lqd-modal-content relative z-[100] max-h-[95vh] min-w-[min(calc(100%-2rem),540px)] overflow-y-auto overscroll-contain rounded-xl bg-background shadow-2xl shadow-black/10 max-w-680px">
                          <div className="lqd-modal-head flex flex-wrap items-center gap-3 border-b px-4 py-2 relative">
                            <h4 className="my-0">Your Credit List</h4>
                            <button className="lqd-modal-close size-8 ms-auto inline-flex items-center justify-center rounded-lg transition-all hover:bg-foreground/20" type="button" onClick={() => setModalOpenView(false)}>
                              <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M18 6l-12 12"></path>
                                <path d="M6 6l12 12"></path>
                              </svg>
                            </button>
                          </div>

                          <div className="lqd-modal-body p-10">
                            <div className="container p-0">
                              <h3 className="mb-2 text-left">Unlock your creativity with credits</h3>
                              <p className="mb-5 text-left font-size-14">Each credit unlocks powerful AI tools and features designed to enhance your content creation.</p>

                              <div className="credit-list-partial" id="credit-list-partial-880661">
                                <table className="mb-4 w-full table-auto border-collapse border">
                                  <thead>
                                    <tr className="bg-foreground/10">
                                      <th className="border p-2 text-start">Model</th>
                                      <th className="border p-2 text-end">Credits</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Images
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">sd3-turbo</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">unsplash</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">pexels</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">pixabay</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">dall-e-3</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-image-1</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">nano-banana</span>
                                                <span className="text-end font-medium">69</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">nano-banana/edit</span>
                                                <span className="text-end font-medium">100</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">flux-pro</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">flux-pro/kontext/max/multi</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">flux-pro/kontext/text-to-image</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">flux-pro/kontext</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">ideogram-v2</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">midjourney</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">black-forest-labs/FLUX.1-schnell</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Words
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4-turbo</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4-1106-preview</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4-0125-preview</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4o</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4o-search-preview</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4o-mini-search-preview</span>
                                                <span className="text-end font-medium">1000000</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">o1-mini</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">o3-mini</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4o-realtime-preview-2024-12-17</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4.1-mini</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-4.1-nano</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">o4-mini</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-5</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-5-mini</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-5-nano</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gpt-5-chat-latest</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">text-embedding-3-small</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">gemini-2.5-pro</span>
                                                <span className="text-end font-medium">99962</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">serper</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">perplexity/llama-3.1-sonar-small-128k-chat</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Characters
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">elevenlabs-voice-chatbot</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">isolator</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Minutes
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 top-full -translate-y-1 before:-bottom-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">elevenlabs-ai-music</span>
                                                <span className="text-end font-medium">42</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        42
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Seconds
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">sora-2-pro</span>
                                                <span className="text-end font-medium">16</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        16
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Image to Video
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">image-to-video</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">klingV21</span>
                                                <span className="text-end font-medium">7</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">klingImage</span>
                                                <span className="text-end font-medium">12</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Video
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">video-upscaler</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">cogvideox-5b/video-to-video</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">animatediff-v2v</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">fast-animatediff/turbo/video-to-video</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">ad-marketing-video</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">ad-marketing-video-topview</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">ai-clip-klap</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Text to Speech
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">elevenlabs</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">tts-1</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">tts-1-hd</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">music-01</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Speech to Text
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">whisper-1</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>

                                    <tr>
                                      <td className="flex justify-between border-b p-2">
                                        Text to Video
                                        <span
                                          className="lqd-tooltip-container group relative inline-flex cursor-default before:absolute before:-start-1.5 before:-top-1.5 before:h-7 before:w-7 [&amp;:hover&gt;.lqd-tooltip-content]:visible [&amp;:hover&gt;.lqd-tooltip-content]:translate-y-0 [&amp;:hover&gt;.lqd-tooltip-content]:opacity-100"
                                        >
                                          <span className="lqd-tooltip-icon opacity-40">
                                            <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                              <path
                                                d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                                                stroke-width="0"
                                                fill="currentColor"
                                              ></path>
                                            </svg>
                                          </span>
                                          <span
                                            className="lqd-tooltip-content min-w-64 invisible absolute start-1/2 z-50 mb-3 -translate-x-1/2 rounded-xl bg-background/80 px-4 py-3 text-center text-xs leading-normal text-foreground opacity-0 shadow-lg shadow-black/5 backdrop-blur-sm backdrop-saturate-150 transition-all before:absolute before:inset-x-0 before:h-3 bottom-full translate-y-1 before:-top-3 max-h-48 overflow-y-auto"
                                          >
                                            <div>
                                              <h5 className="font-semibold">Credits Details</h5>
                                              <hr className="my-3 border-heading-foreground/10" />

                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">veo2</span>
                                                <span className="text-end font-medium">13</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">veed</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">veo3</span>
                                                <span className="text-end font-medium">4</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">veo3-fast</span>
                                                <span className="text-end font-medium">3</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">kling-video</span>
                                                <span className="text-end font-medium">13</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">kling</span>
                                                <span className="text-end font-medium">10</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">ad-marketing-video</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">ad-marketing-video-topview</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                              <div className="flex justify-between gap-x-1 border-b py-1.5 text-2xs last:border-b-0">
                                                <span className="text-start">ai-clip-klap</span>
                                                <span className="text-end font-medium">Unlimited</span>
                                              </div>
                                            </div>
                                          </span>
                                        </span>
                                      </td>
                                      <td className="border p-2 text-end">
                                        Unlimited
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div className="mt-4 border-t pt-3 text-end">
                                <a
                                  onClick={() => setModalOpenView(false)}
                                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-outline outline outline-button-border -outline-offset-1 focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-secondary lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                                  href="#"
                                >
                                  Close
                                </a>
                                <a
                                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                                  href="#"
                                >
                                  Upgrade Plan
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <a
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md py-2 px-4 lqd-btn-hover-none hover:bg-primary"
                  data-name="select_plan"
                  href="/payment"
                >
                  <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 5l0 14"></path>
                    <path d="M5 12l14 0"></path>
                  </svg>
                  Select a Plan
                </a>
              </div>
            </div>
          </div>

          <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card relative flex w-full justify-center bg-cover bg-top text-center lg:w-[48%]">
            <div className='navigation-wrapper'>
              {packageHighLight.length > 0 ? (
                <div ref={sliderRef} className="keen-slider">
                  {packageHighLight.map((item, index) => (
                    <div key={index} className="keen-slider__slide number-slide1 lqd-card-body lqd-card-md px-7 flex flex-col only:grow-0 py-8 xl:px-20 static">
                      <figure className="pointer-events-none absolute start-0 top-0 z-0 h-full w-full overflow-hidden transition-opacity dark:opacity-60" aria-hidden="true">
                        <img className="w-full" src="https://demo.magicproject.ai/themes/default/assets/img/bg/premium-card-bg.jpg" alt="Premium Features" />
                      </figure>
                      <div className="relative z-1 flex flex-col">
                        <h4 className="mb-5 text-[17px] text-lg">
                          {item?.content?.val1}
                        </h4>
                        <p className="mb-8 text-xs font-medium opacity-60">
                          {item?.content?.val3 || 'Not thing'}
                        </p>
                        <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <linearGradient id="premium-icon-gradient" x1="0.546875" y1="3.69866" x2="12.7738" y2="14.7613" gradientUnits="userSpaceOnUse">
                              <stop stop-color="hsl(var(--gradient-from))"></stop>
                              <stop offset="0.502" stop-color="hsl(var(--gradient-via))"></stop>
                              <stop offset="1" stop-color="hsl(var(--gradient-to))"></stop>
                            </linearGradient>
                          </defs>
                        </svg>
                        <ul className="mb-11 space-y-4 self-center text-xs font-medium">
                          {item?.content?.val5 ? (
                            item?.content?.val5.map((itemChild: any) => (
                              <li key={itemChild.id} className="flex items-center gap-3.5">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M2.09635 7.37072C1.80296 7.37154 1.51579 7.45542 1.26807 7.61264C1.02035 7.76986 0.822208 7.994 0.696564 8.25914C0.570919 8.52427 0.522908 8.81956 0.558084 9.11084C0.59326 9.40212 0.710186 9.67749 0.895335 9.9051L4.84228 14.7401C4.98301 14.9148 5.1634 15.0535 5.36847 15.1445C5.57353 15.2355 5.79736 15.2763 6.02136 15.2635C6.50043 15.2377 6.93295 14.9815 7.20871 14.5601L15.4075 1.35593C15.4089 1.35373 15.4103 1.35154 15.4117 1.34939C15.4886 1.23127 15.4637 0.997192 15.3049 0.850142C15.2613 0.809761 15.2099 0.778736 15.1538 0.75898C15.0977 0.739223 15.0382 0.731153 14.9789 0.735266C14.9196 0.739379 14.8618 0.755589 14.809 0.782896C14.7562 0.810204 14.7095 0.848031 14.6719 0.894048C14.669 0.897666 14.6659 0.90123 14.6628 0.904739L6.39421 10.247C6.36275 10.2826 6.32454 10.3115 6.28179 10.3322C6.23905 10.3528 6.19263 10.3648 6.14522 10.3674C6.09782 10.3699 6.05038 10.363 6.00565 10.3471C5.96093 10.3312 5.91982 10.3065 5.88471 10.2746L3.14051 7.77735C2.8555 7.51608 2.48299 7.37102 2.09635 7.37072Z"
                                    fill="url(#premium-icon-gradient)"
                                  ></path>
                                </svg>
                                {itemChild?.val1 || Nothing}
                              </li>
                            ))
                          ) : (
                            <p>Not thing</p>
                          )}
                        </ul>
                        <Link
                          className="lqd-btn group inline-flex items-center justify-center gap-1.5 rounded-button transition-all hover:-translate-y-0.5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground hover:bg-primary hover:text-primary-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md px-4 lqd-btn-hover-none py-[18px] text-[18px] font-bold leading-6 shadow-[0_14px_44px_rgba(0,0,0,0.07)] hover:shadow-2xl hover:shadow-primary/30 dark:hover:bg-primary"
                          to={`/checkout/${item?.slug}`}
                        >
                          <span className="bg-gradient-to-r from-gradient-from via-gradient-via to-gradient-to bg-clip-text font-bold text-transparent group-hover:from-white group-hover:via-white group-hover:to-white/80"> Upgrade Your Plan </span>
                        </Link>
                      </div>
                    </div>
                  ))}
                  {loaded && instanceRef.current && instanceRef.current.track && (
                    <>
                      <Arrow
                        left
                        onClick={(e: any) =>
                          e.stopPropagation() || instanceRef.current?.prev()
                        }
                        disabled={currentSlide === 0}
                      />
                      <Arrow
                        onClick={(e: any) =>
                          e.stopPropagation() || instanceRef.current?.next()
                        }
                        disabled={
                          currentSlide === instanceRef?.current?.track?.details?.slides?.length - 1
                        }
                      />
                    </>
                  )}
                </div>
              ) : (
                <p>Not thing</p>
              )}
            </div>
          </div>

          <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card w-full" id="summary">
            <div className="lqd-card-body relative only:grow lqd-card-lg py-8 px-10">
              {/* <div className="flex justify-between max-lg:flex-wrap lg:mb-7">
                <h3 className="items-center text-[17px] leading-6 lg:mb-0">
                  Account Summary
                </h3>
                <div className="flex w-full justify-between max-lg:flex-wrap lg:w-3/5">
                  <div className="relative flex grow flex-col justify-center lg:ps-12 lg:after:absolute lg:after:right-0 lg:after:h-[80%] lg:after:w-px lg:after:bg-border">
                    <p className="text-nowrap text-sm leading-5">Hours Saved</p>
                    <h2>342</h2>
                  </div>
                  <div className="relative flex grow flex-col justify-center lg:ps-12 lg:after:absolute lg:after:right-0 lg:after:h-[80%] lg:after:w-px lg:after:bg-border">
                    <p className="text-nowrap text-sm leading-5">Documents</p>
                    <h2>114</h2>
                  </div>
                  <div className="flex grow flex-col justify-center lg:ps-12">
                    <p className="text-nowrap text-sm leading-5">Chatbots</p>
                    <h2>0</h2>
                  </div>
                </div>
              </div> */}

              {/* <hr /> */}

              <div className="flex flex-col gap-4 sm:py-6">
                <h4 className="text-foreground/80">Document Overview</h4>
                <div className="flex flex-nowrap items-center gap-10 max-sm:flex-wrap max-sm:gap-4">
                  <div className="flex h-[10px] w-full flex-nowrap gap-0.5 overflow-hidden rounded-lg">
                    <span className="bg-accent" style={{ width: '19.047619047619%' }}></span>
                    <span className="bg-[#1CA685]" style={{ width: '78.095238095238%' }}></span>
                    <span className="bg-[#667085]" style={{ width: '2.8571428571429%' }}></span>
                  </div>
                  <a
                    className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent text-foreground hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none"
                    href="#"
                  >
                    <span className="text-nowrap font-bold text-foreground">View All</span>
                    <svg className="size-4 rtl:rotate-180" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M9 6l6 6l-6 6"></path>
                    </svg>
                  </a>
                </div>
                <div className="inline-flex flex-wrap gap-7 px-2 pt-1 max-sm:gap-3">
                  <div className="inline-flex items-center gap-2">
                    <span className="size-2.5 rounded-sm bg-accent"></span>
                    <span className="text-sm leading-5 text-heading-foreground">Text</span>
                    <span className="leading-5 text-foreground/70">20</span>
                  </div>
                  <div className="inline-flex items-center gap-2">
                    <span className="size-2.5 rounded-sm bg-[#1CA685]"></span>
                    <span className="text-sm leading-5 text-heading-foreground">Image</span>
                    <span className="leading-5 text-foreground/70">82</span>
                  </div>
                  <div className="inline-flex items-center gap-2">
                    <span className="size-2.5 rounded-sm bg-[#667085]"></span>
                    <span className="text-sm leading-5 text-heading-foreground">Audio</span>
                    <span className="leading-5 text-foreground/70">3</span>
                  </div>
                  <div className="inline-flex items-center gap-2">
                    <span className="size-2.5 rounded-sm bg-[#E6E7E9]"></span>
                    <span className="text-sm leading-5 text-heading-foreground">Other</span>
                    <span className="leading-5 text-foreground/70">9</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card w-full lg:w-[48%]" id="team">
            <div className="lqd-card-body relative only:grow lqd-card-lg py-8 px-10">
              <figure className="mb-7">
                <img className="mx-auto w-full lg:w-7/12" src="https://demo.magicproject.ai/themes/default/assets/img/team/team.png" alt="Team" />
              </figure>
              <p className="mb-6 text-center text-xl font-semibold">
                Add your team members’ email address <br />
                to start collaborating. 📧
              </p>
              <form className="flex flex-col gap-3" action="https://demo.magicproject.ai/dashboard/user/team/2/invitation" method="post">
                <input type="hidden" name="_token" value="x0TLoGSgIIRC3Ax5nJhDfoSIhg918OdCJCZgIchp" /> <input type="hidden" name="team_id" value="2" />
                <div className="lqd-input-container relative">
                  <div className="relative">
                    <input
                      id="email"
                      className="lqd-input block peer w-full px-4 py-2 border border-input-border bg-input-background text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg h-11 mb-6"
                      name="email"
                      value=""
                      type="email"
                      placeholder="Email address"
                    />
                    <svg
                      className="absolute end-3 top-1/2 size-5 -translate-y-1/2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"></path>
                      <path d="M3 7l9 6l9 -6"></path>
                    </svg>
                  </div>
                </div>
                <a
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                  href="#"
                >
                  Invite Friends
                </a>
              </form>
            </div>
          </div>

          <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card flex w-full flex-col lg:w-[48%]" id="invite-friend">
            <div className="lqd-card-body relative only:grow lqd-card-md py-5 px-7">
              <div className="w-fit rounded-card bg-accent/[7%] p-4 dark:bg-foreground/5">
                <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M26.4595 16.7999H1.65428V24.3596C1.65524 25.4733 2.09117 26.5411 2.86639 27.3286C3.64161 28.1162 4.69276 28.559 5.78908 28.56H22.3247C23.421 28.559 24.4721 28.1162 25.2474 27.3286C26.0226 26.5411 26.4585 25.4733 26.4595 24.3596V16.7999ZM11.5764 26.0401C11.5764 26.263 11.4892 26.4767 11.3341 26.6343C11.179 26.7918 10.9686 26.8804 10.7492 26.8804C10.5298 26.8804 10.3195 26.7918 10.1643 26.6343C10.0092 26.4767 9.92208 26.263 9.92208 26.0401V19.3198C9.92208 19.0969 10.0092 18.8832 10.1643 18.7256C10.3195 18.568 10.5298 18.4795 10.7492 18.4795C10.9686 18.4795 11.179 18.568 11.3341 18.7256C11.4892 18.8832 11.5764 19.0969 11.5764 19.3198V26.0401ZM18.1917 26.0401C18.1917 26.263 18.1045 26.4767 17.9494 26.6343C17.7943 26.7918 17.5839 26.8804 17.3645 26.8804C17.1452 26.8804 16.9348 26.7918 16.7797 26.6343C16.6245 26.4767 16.5374 26.263 16.5374 26.0401V19.3198C16.5374 19.0969 16.6245 18.8832 16.7797 18.7256C16.9348 18.568 17.1452 18.4795 17.3645 18.4795C17.5839 18.4795 17.7943 18.568 17.9494 18.7256C18.1045 18.8832 18.1917 19.0969 18.1917 19.3198V26.0401ZM23.979 6.72032H20.6505C21.1737 6.01659 21.4984 5.14974 21.4984 4.20043C21.4975 3.0867 21.0615 2.01887 20.2863 1.23135C19.5111 0.443826 18.46 0.000970568 17.3636 0C16.007 0 14.811 0.67808 14.0569 1.7062C13.6752 1.17926 13.1773 0.750582 12.603 0.454585C12.0287 0.158587 11.3941 0.00351906 10.7501 0.00183252C9.65411 0.00280228 8.60323 0.445406 7.82806 1.23253C7.0529 2.01966 6.61675 3.08702 6.61532 4.20043C6.61532 5.14974 6.94004 6.01475 7.4632 6.72032H4.1348C3.03848 6.72129 1.98733 7.16415 1.21211 7.95167C0.436891 8.7392 0.000955403 9.80703 0 10.9208V12.5995C0 13.9904 1.11308 15.1194 2.48052 15.1194H25.6332C27.0007 15.1194 28.1137 13.9904 28.1137 12.5995V10.9208C28.1128 9.80703 27.6769 8.7392 26.9016 7.95167C26.1264 7.16415 25.0753 6.72129 23.979 6.72032ZM11.5764 12.5995C11.5764 12.8223 11.4892 13.036 11.3341 13.1936C11.179 13.3512 10.9686 13.4397 10.7492 13.4397C10.5298 13.4397 10.3195 13.3512 10.1643 13.1936C10.0092 13.036 9.92208 12.8223 9.92208 12.5995V9.24022C9.92208 9.01736 10.0092 8.80364 10.1643 8.64606C10.3195 8.48847 10.5298 8.39995 10.7492 8.39995C10.9686 8.39995 11.179 8.48847 11.3341 8.64606C11.4892 8.80364 11.5764 9.01736 11.5764 9.24022V12.5995ZM13.2306 6.72032H10.7501C10.0924 6.71984 9.46174 6.45419 8.99665 5.98173C8.53157 5.50926 8.27008 4.8686 8.2696 4.20043C8.29407 3.54874 8.56612 2.93203 9.02863 2.47976C9.49114 2.02749 10.1081 1.77483 10.7501 1.77483C11.3921 1.77483 12.0091 2.02749 12.4716 2.47976C12.9341 2.93203 13.2062 3.54874 13.2306 4.20043V6.72032ZM18.1917 12.5995C18.1917 12.8223 18.1045 13.036 17.9494 13.1936C17.7943 13.3512 17.5839 13.4397 17.3645 13.4397C17.1452 13.4397 16.9348 13.3512 16.7797 13.1936C16.6245 13.036 16.5374 12.8223 16.5374 12.5995V9.24022C16.5374 9.01736 16.6245 8.80364 16.7797 8.64606C16.9348 8.48847 17.1452 8.39995 17.3645 8.39995C17.5839 8.39995 17.7943 8.48847 17.9494 8.64606C18.1045 8.80364 18.1917 9.01736 18.1917 9.24022V12.5995ZM17.3636 6.72032H14.8831V4.20043C14.8831 2.81128 15.9962 1.68054 17.3636 1.68054C18.7311 1.68054 19.8442 2.81128 19.8442 4.20043C19.8442 5.58958 18.7311 6.72032 17.3636 6.72032Z"
                    fill="hsl(var(--accent))"
                  ></path>
                </svg>
              </div>
              <div className="flex flex-col gap-3 pt-4">
                <p className="mb-4 text-xl font-semibold text-foreground">
                  Invite your friends and earn lifelong recurring commissions. 💸
                </p>
                <span className="text-xs leading-5 text-foreground/80">Simply share your referral link and have your friends sign up through it.</span>
                <div className="flex items-center gap-3 max-sm:flex-wrap">
                  <p className="mb-0 text-xs leading-5">
                    <span className="opacity-60">
                      Commission Rate:
                    </span>
                    10%
                  </p>
                  <span className="bg-foreground\/10 h-1 w-1 rounded-full max-sm:hidden"></span>
                  <p className="mb-0 text-xs leading-5">
                    <span className="opacity-60">
                      Referral Program:
                    </span>
                    All Purchases
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-6 sm:pt-7">
                <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card w-full" id="earning">
                  <div className="lqd-card-body relative only:grow lqd-card-sm p-4 flex justify-between items-center">
                    <span className="text-xs font-semibold text-foreground">Earnings</span>
                    <span className="text-lg font-semibold">$<strong className="text-[30px]">0</strong></span>
                  </div>
                </div>

                <div x-data="{}" className="lqd-card text-card-foreground bg-card-background w-full transition-all group/card lqd-card-outline border border-card-border rounded-card">
                  <div className="lqd-card-body relative only:grow lqd-card-xs px-5 py-3">
                    <input id="invite-url" type="hidden" value={referralCode} />

                    <div className="flex items-center justify-between gap-2">
                      <p className="m-0 text-xs leading-5">
                        {referralLink}
                      </p>

                      <a
                        className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-variant-none hover:shadow-none lqd-btn-size-none lqd-btn-hover-none"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          copyTextToClipboard(referralLink);
                        }}
                      >
                        <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z"></path>
                          <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1"></path>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card flex w-full flex-col lg:w-[100%]" id="favorite-chatbots">
            <div className="lqd-card-head border-card-border px-6 py-3.5 relative transition-border pb-0 pt-5 border-0">
              <div className="flex items-center justify-between">
                <h4 className="m-0 text-[17px]">Favorite Chatbots</h4>
                <a
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent text-foreground hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none"
                  href="/ai-chat"
                >
                  <span className="text-nowrap font-bold text-foreground"> View All </span>
                  <svg className="size-4 rtl:rotate-180" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 6l6 6l-6 6"></path>
                  </svg>
                </a>
              </div>
            </div>
            <div className="lqd-card-body relative only:grow lqd-card-md py-5 px-7">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">

                {AIChat ? (
                  AIChat.slice(0, 4).map((item, index) => (
                    <div key={index} className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card flex w-full flex-col">
                      <div className="lqd-card-body relative only:grow lqd-card-sm p-4 space-y-3">
                        <a className="absolute left-0 top-0 z-2 block h-full w-full" href={`/ai-chat-bot/${item.id}`}></a>
                        <div className="!mt-0 flex items-center overflow-hidden rounded-full max-sm:mx-auto" style={{ width: '61px', height: '61px', background: '#d4d4e2' }}>
                          <img className="lqd-chat-avatar-img h-full w-full object-cover object-center" src={item.avatar || 'https://sharai.net/themes/default/assets/img/chat-default.jpg'} alt={item.name} />
                        </div>
                        <h4 className="font-medium max-sm:text-center">{item.name}</h4>
                        <div className="flex w-fit rounded-xl border px-2 py-1 max-sm:mx-auto">
                          <span className="text-center">{item.content}</span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <span>Not found</span>
                )}
              </div>
            </div>
          </div>

          <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card w-full" id="templates">
            <div className="lqd-card-head border-card-border px-6 py-3.5 relative transition-border border-0 pb-0 pt-5">
              <div className="flex items-center justify-between">
                <h4 className="m-0 text-[17px]">Favorite Templates</h4>
                <a
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent text-foreground hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none"
                  href="/user/ai-writer"
                >
                  <span className="text-nowrap font-bold text-foreground"> View All </span>
                  <svg className="size-4 rtl:rotate-180" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 6l6 6l-6 6"></path>
                  </svg>
                </a>
              </div>
            </div>
            <div className="lqd-card-body relative only:grow lqd-card-md py-5 px-7">
              <div className="lqd-docs-container group" data-view-mode="grid">
                <div className="lqd-docs-list grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-5 lg:max-xl:grid-cols-3">
                  {AIWriter ? (
                    AIWriter.slice(0, 5).map((item, index) => (
                      <a
                        key={index}
                        className="lqd-posts-item relative flex w-full flex-col flex-wrap items-start gap-3 border-b p-4 text-xs transition-all last:border-none hover:bg-foreground/5"
                        href={`/user/openai/${item.id}`}
                      >
                        <span
                          className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-[--color] text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-lg size-10"
                          // style={{ ['--color' as any]: '#e4cd9f' }}
                          style={{
                            ...(item.avatar
                              ? {
                                backgroundImage: `url(${item.avatar})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                              }
                              : {
                                ['--color' as any]: '#e4cd9f',
                              }
                            ),
                          }}
                        >
                          <span
                            className={item.avatar ? "flex size-5 items-center justify-center transition-transform group-hover:scale-110 d-none" : "flex size-5 items-center justify-center transition-transform group-hover:scale-110"}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M80 236v-60h800v60H80Zm210 250V386h380v100H290Zm0 240V626h380v100H290Z"></path></svg>
                          </span>

                          <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                        </span>
                        <span className="w-full grow">
                          <span className="lqd-fav-temp-item-title block text-sm font-medium">
                            {item.name}
                          </span>
                          <div className="lqd-posts-item-content-inner h-full">
                            <span className="lqd-fav-temp-item-desc line-clamp-4 max-w-full text-ellipsis italic opacity-45">
                              {item.content}
                            </span>
                          </div>
                        </span>
                      </a>
                    ))
                  ) : (
                    <span>Not found</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card flex w-full flex-col lg:w-[48%]" id="add-new">
            <div className="lqd-card-head border-b border-card-border px-6 py-3.5 relative transition-border">
              <h4 className="m-0 text-[17px]">Announcements</h4>
            </div>
            <div className="lqd-card-body relative only:grow lqd-card-md py-5 px-7">
              <ul className="flex flex-col overflow-hidden">
                <li className="flex flex-nowrap items-center justify-between gap-2 py-4 sm:gap-16">
                  <div className="flex flex-nowrap items-center gap-3">
                    <div className="after:absolute after:w-px after:-bottom-12 after:start-1/2 after:h-12 after:-z-1 after:bg-foreground/10 relative flex-shrink-0">
                      <svg
                        style={{ background: '#49aede' }}
                        strokeWidth={1.5}
                        className="size-8 rounded-full stroke-white p-1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path
                          d="M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
                        ></path>
                        <path d="M12 9h.01"></path>
                        <path d="M11 12h1v4h1"></path>
                      </svg>
                    </div>
                    <span className="line-clamp-2 font-semibold text-heading-foreground text-xs">
                      AI Chat Bots recently launched!
                    </span>
                  </div>
                  <div className="flex flex-shrink-0 flex-col items-end gap-1">
                    <span className="font-semibold text-heading-foreground text-xs">Info</span>
                    <span className="text-xs">Aug 28,2025</span>
                  </div>
                </li>
                <li className="flex flex-nowrap items-center justify-between gap-2 py-4 sm:gap-16">
                  <div className="flex flex-nowrap items-center gap-3">
                    <div className="relative flex-shrink-0">
                      <svg
                        style={{ background: '#9a34cd' }}
                        strokeWidth={1.5}
                        className="size-8 rounded-full stroke-white p-1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M18 8a3 3 0 0 1 0 6"></path>
                        <path d="M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"></path>
                        <path d="M12 8h0l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8"></path>
                      </svg>
                    </div>
                    <span className="line-clamp-2 font-semibold text-heading-foreground text-xs">
                      Welcome To MagicAI
                    </span>
                  </div>
                  <div className="flex flex-shrink-0 flex-col items-end gap-1">
                    <span className="font-semibold text-heading-foreground text-xs">New</span>
                    <span className="text-xs">Aug 28,2025</span>
                  </div>
                </li>
              </ul>
            </div>
          </div> */}

          {/* <div className="lqd-card text-card-foreground bg-card-background transition-all group/card lqd-card-outline border border-card-border rounded-card flex w-full flex-col justify-center lg:w-[48%]" id="submit-ticket">
            <div className="lqd-card-body relative only:grow lqd-card-lg py-8 px-10">
              <div className="flex flex-col gap-8">
                <div className="flex flex-col items-center gap-3">
                  <div className="inline-grid size-36 items-center justify-center rounded-full bg-foreground/[3%]">
                    <img src="https://demo.magicproject.ai/images/icons/submit-ticket.png" alt="" />
                  </div>
                  <div className="flex flex-col items-center">
                    <h3 className="text-center">Have a question? <span className="mt-1.5 block opacity-50"> We’re here to help you. </span></h3>
                  </div>
                </div>
                <a
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background shadow-xs hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md py-2 px-4 lqd-btn-hover-none mx-auto w-fit text-xs text-heading-foreground hover:bg-primary"
                  href="#"
                >
                  <svg className="size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 5l0 14"></path>
                    <path d="M5 12l14 0"></path>
                  </svg>
                  Submit a Ticket
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </Layout >
  )
}

export default User
